export default __webpack_public_path__ + "static/media/banner.630a2d60.jpg";